import i18n from "../../../../../constants/i18n";
import getCorePopUpStore from "../../../../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";
import Et3Text from "../../../../et3-text";

const SuccessAndHelperAlertHeaderText = withLiteObserverAndTheme(() => {
  const aletHeader = getCorePopUpStore().alertHeader.get();
  const alertColor = getCorePopUpStore().alertColor.get();

  return (
    <Et3Text
      fontFamily={"BOLD"}
      fontSize={40}
      text={i18n.get(aletHeader)}
      isSpan={false}
      color={alertColor}
      style={{}}
    />
  );
});
export default SuccessAndHelperAlertHeaderText;
